module.exports = __webpack_public_path__ + "img/zcfont.5dddc60c.png";